import { render } from "./BrandDetails.vue?vue&type=template&id=1d16f140"
import script from "./BrandDetails.vue?vue&type=script&lang=js"
export * from "./BrandDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__